// if job form present on page and a job apply button is pressed, will scroll user to that form and prefill the job title field
// if job form not present will remove the apply buttons

import { scrollToTarget } from "./helpers/scroll-to-target";

window.addEventListener('load', event => {
    let jobPanels = document.querySelectorAll('.jobs-panel');
    for (let jobPanel of jobPanels) {
        let availableJobs = jobPanel.querySelectorAll('[data-job-available]');
        let jobForm = document.querySelector('#jobForm');

        for (let availableJob of availableJobs) {
            const jobTitle = availableJob.dataset.jobAvailable;
            let applyButton = availableJob.querySelector('button');

            if (jobForm) {
                let jobTitleInput = jobForm.querySelector('input[name="jobTitle"]');

                applyButton.addEventListener('click', event => {
                    if (jobTitleInput) {
                        jobTitleInput.value = jobTitle;
                    }
                    scrollToTarget(jobForm);
                });
            } else {
                applyButton.remove();
            }
        }
    }
});